<template lang="pug">
  #app
    v-app
      router-view
    notifications(group="foo", position="top right")
    loading(:active.sync="isLoading", :can-cancel="false")
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.min.css";

export default {
  components: {
    Loading
  },
  data() {
    return {};
  },
  computed: {
    isLoading() {
      return this.$store.state.isLoading;
    },
    showNotification() {
      return this.$store.state.showNotification;
    }
  },
  watch: {
    showNotification() {
      if (this.$store.state.showNotification) {
        this.$notify({
          group: "foo",
          type: this.$store.state.showNotification.type,
          title: this.$store.state.showNotification.title,
          text: this.$store.state.showNotification.text
        });

        this.$store.commit("setShowNotification", null);
      }
    }
  }
};
</script>

<style lang="scss">
#app {
  background-color: #fff;

  #home {
    /*
    .divider.form {
      color: $light-medium !important;
      height: 3px !important;
    }
    */

    .link,
    .link a {
      color: #4a4a4a;
      text-transform: uppercase;
      text-decoration: underline;
      font-size: 17px;
      font-weight: 600;
      &:hover {
        font-weight: 700;
      }
    }
  }

  
    .form-title {
      font-size: 24px;
    }
    .form-title2 {
      font-size: 19px;
      color: black;
      font-weight: bold;
    }


  label.custom {
    font-size: 11.5px;
    color: rgba(0, 0, 0, 0.54);
  }

  label.custom-secondary {
    font-size: 12.5px;
    color: rgba(0, 0, 0, 0.54);
  }

  .side-label {
    display: flex;
    align-items: flex-end;
  }

  .add-button {
    align-items: center;
    height: 40px;
    .btn--outline {
      width: 25px !important;
      height: 25px !important;
    }
  }

  .go-to {
    display: flex !important;
    align-content: center;
  }
}
</style>
